function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  width: 90,
  height: 8,
  x: 23,
  y: 95,
  fill: "#073C50",
  fillRule: "nonzero"
}), React.createElement("path", {
  stroke: "#073C50",
  strokeDasharray: 5,
  strokeWidth: 2,
  d: "M48,23 L108,23 L108,23 L108,96 L28,96 L28,43 C28,31.954305 36.954305,23 48,23 Z"
}), React.createElement("rect", {
  width: 33,
  height: 5,
  x: 42,
  y: 48,
  fill: "#DEDEDE",
  fillRule: "nonzero"
}), React.createElement("rect", {
  width: 53,
  height: 5,
  x: 42,
  y: 57,
  fill: "#DEDEDE",
  fillRule: "nonzero"
}), React.createElement("rect", {
  width: 53,
  height: 5,
  x: 42,
  y: 66,
  fill: "#DEDEDE",
  fillRule: "nonzero"
}), React.createElement("rect", {
  width: 16,
  height: 5,
  x: 42,
  y: 75,
  fill: "#DEDEDE",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#073C50",
  fillRule: "nonzero",
  d: "M47.8727274 10.7939392C55.8018205 18.7230323 56.7904794 30.9643582 50.8387044 39.9688145L64.4085861 53.5386868 57.847778 60.0994949 44.2844515 46.5368671C35.2761946 52.5187105 23.0097885 51.5390814 15.0686869 43.5979797 6.01010127 34.5393941 6.01010127 19.8525249 15.0686869 10.7939392 24.1272726 1.73535359 38.8141418 1.73535359 47.8727274 10.7939392zM21.629495 17.3547473C16.1943436 22.7898987 16.1943436 31.6020203 21.629495 37.0371716 27.0646464 42.472323 35.8767679 42.472323 41.3119193 37.0371716 46.7470707 31.6020203 46.7470707 22.7898987 41.3119193 17.3547473 35.8767679 11.9195959 27.0646464 11.9195959 21.629495 17.3547473zM128.675636 57.8758456L128.675636 61.8327261 127.356675 61.8327261 127.356675 57.8758456 128.675636 57.8758456zM130.544001 56.2542808L133.97076 58.2327211 133.31128 59.3749741 129.884521 57.3965338 130.544001 56.2542808zM125.397519 56.2542808L126.056999 57.3965338 122.63024 59.3749741 121.97076 58.2327211 125.397519 56.2542808zM122.63024 51.457752L126.056999 53.4361923 125.397519 54.5784453 121.97076 52.600005 122.63024 51.457752zM133.31128 51.457752L133.97076 52.600005 130.544001 54.5784453 129.884521 53.4361923 133.31128 51.457752zM128.584844 49L128.584844 52.9568805 127.265884 52.9568805 127.265884 49 128.584844 49zM7.67563552 81.8758456L7.67563552 85.8327261 6.35667536 85.8327261 6.35667536 81.8758456 7.67563552 81.8758456zM9.5440006 80.2542808L12.9707596 82.2327211 12.3112795 83.3749741 8.88452052 81.3965338 9.5440006 80.2542808zM4.3975186 80.2542808L5.05699867 81.3965338 1.63023967 83.3749741.970759597 82.2327211 4.3975186 80.2542808zM1.63023967 75.457752L5.05699867 77.4361923 4.3975186 78.5784453.970759597 76.600005 1.63023967 75.457752zM12.3112795 75.457752L12.9707596 76.600005 9.5440006 78.5784453 8.88452052 77.4361923 12.3112795 75.457752zM7.58484383 73L7.58484383 76.9568805 6.26588368 76.9568805 6.26588368 73 7.58484383 73zM83.6756355 8.87584564L83.6756355 12.8327261 82.3566754 12.8327261 82.3566754 8.87584564 83.6756355 8.87584564zM85.5440006 7.25428085L88.9707596 9.23272108 88.3112795 10.3749741 84.8845205 8.39653385 85.5440006 7.25428085zM80.3975186 7.25428085L81.0569987 8.39653385 77.6302397 10.3749741 76.9707596 9.23272108 80.3975186 7.25428085zM77.6302397 2.45775203L81.0569987 4.43619226 80.3975186 5.57844526 76.9707596 3.60000503 77.6302397 2.45775203zM88.3112795 2.45775203L88.9707596 3.60000503 85.5440006 5.57844526 84.8845205 4.43619226 88.3112795 2.45775203zM83.5848438 0L83.5848438 3.95688046 82.2658837 3.95688046 82.2658837 0 83.5848438 0z"
}));

var SvgNoData = function SvgNoData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 134,
    height: 103,
    viewBox: "0 0 134 103",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NoData.1bd657ce.svg";
export { ForwardRef as ReactComponent };